var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 6.414 9.414 5h5.172L16 6.414A2 2 0 0 0 17.414 7H19a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.586A2 2 0 0 0 8 6.414l-.683-.683zm.707-2.121L7.293 5.707A1 1 0 0 1 6.586 6H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-1.586a1 1 0 0 1-.707-.293l-1.414-1.414A1 1 0 0 0 14.586 4H9.414a1 1 0 0 0-.707.293M17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0m1 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
    clipRule: "evenodd"
  })));
});
const SvgCamera = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDYuNDE0MjFMOS40MTQyMSA1TDE0LjU4NTggNUwxNiA2LjQxNDIxQzE2LjM3NTEgNi43ODkyOSAxNi44ODM4IDcgMTcuNDE0MiA3SDE5QzIwLjEwNDYgNyAyMSA3Ljg5NTQzIDIxIDlWMThDMjEgMTkuMTA0NiAyMC4xMDQ2IDIwIDE5IDIwSDVDMy44OTU0MyAyMCAzIDE5LjEwNDYgMyAxOFY5QzMgNy44OTU0MyAzLjg5NTQzIDcgNSA3SDYuNTg1NzlDNy4xMTYyMiA3IDcuNjI0OTMgNi43ODkyOSA4IDYuNDE0MjFMNy4zMTcyOCA1LjczMTQ5TDggNi40MTQyMVpNOC43MDcxMSA0LjI5Mjg5TDcuMjkyODkgNS43MDcxMUM3LjEwNTM2IDUuODk0NjQgNi44NTEgNiA2LjU4NTc5IDZINUMzLjM0MzE1IDYgMiA3LjM0MzE1IDIgOVYxOEMyIDE5LjY1NjkgMy4zNDMxNSAyMSA1IDIxSDE5QzIwLjY1NjkgMjEgMjIgMTkuNjU2OSAyMiAxOFY5QzIyIDcuMzQzMTUgMjAuNjU2OSA2IDE5IDZIMTcuNDE0MkMxNy4xNDkgNiAxNi44OTQ2IDUuODk0NjQgMTYuNzA3MSA1LjcwNzExTDE1LjI5MjkgNC4yOTI4OUMxNS4xMDU0IDQuMTA1MzYgMTQuODUxIDQgMTQuNTg1OCA0SDkuNDE0MjFDOS4xNDkgNCA4Ljg5NDY0IDQuMTA1MzYgOC43MDcxMSA0LjI5Mjg5Wk0xNyAxM0MxNyAxNS43NjE0IDE0Ljc2MTQgMTggMTIgMThDOS4yMzg1OCAxOCA3IDE1Ljc2MTQgNyAxM0M3IDEwLjIzODYgOS4yMzg1OCA4IDEyIDhDMTQuNzYxNCA4IDE3IDEwLjIzODYgMTcgMTNaTTE4IDEzQzE4IDE2LjMxMzcgMTUuMzEzNyAxOSAxMiAxOUM4LjY4NjI5IDE5IDYgMTYuMzEzNyA2IDEzQzYgOS42ODYyOSA4LjY4NjI5IDcgMTIgN0MxNS4zMTM3IDcgMTggOS42ODYyOSAxOCAxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";